<template>
  <div class="layout__container layout__padding-20-0">
    <div class="layout__width-80 layout__padding-clear">
      <el-steps
        class=""
        :active="currentStep"
        align-center
      >
        <el-step
          icon="icon-step-circle stepSize"
          title="Customer details"
        />
        <el-step
          icon="icon-step-circle stepSize"
          title="Company details"
        />
        <el-step
          icon="icon-step-circle stepSize"
          title="Billing details"
        />
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Steps',

  props: {
    currentStep: Number,
  },
};
</script>